import React, { useState } from 'react';
import { Link as LinkR } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { Bio } from '../../data/constants';
import { MenuRounded } from '@mui/icons-material';

const Nav = styled.div`
  background-color: ${({ theme }) => theme.bg};
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  color: white;
  backdrop-filter: blur(8px);
`;

const NavbarContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
`;

const NavLogo = styled(LinkR)`
  padding: 0 6px;
  text-decoration: none;
  color: inherit;
  font-size: 18px;
  font-weight: 600;
`;

const NavItems = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  gap: 28px;
  padding: 0 6px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const GithubButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 6px 18px;
  border-radius: 100px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  transition: all 0.3s ease-in-out;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.text_primary};
  }
`;

const MobileIcon = styled.div`
  color: ${({ theme }) => theme.text_primary};
  display: none;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

const MobileMenu = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  list-style: none;
  gap: 16px;
  padding: 20px 24px 28px 40px;
  background: ${({ theme }) => theme.card_light + 99};
  position: absolute;
  top: 80px;
  right: 0;
  transition: all 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-20px)')};
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  z-index: ${({ isOpen }) => (isOpen ? '1000' : '-1000')};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  const links = [
    { href: '#About', label: 'About' },
    { href: '#Skills', label: 'Skills' },
    { href: '#Experience', label: 'Experience' },
    { href: '#Projects', label: 'Projects' },
    { href: '#Education', label: 'Education' },
    { href: '#Achievements', label: 'Achievements' },
    { href: '#Contact', label: 'Contact' },
  ];

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">Aliza Khan</NavLogo>
        <MobileIcon onClick={() => setIsOpen(!isOpen)}>
          <MenuRounded style={{ color: 'inherit' }} />
        </MobileIcon>
        <NavItems>
          {links.map((link) => (
            <NavLink key={link.href} href={link.href}>
              {link.label}
            </NavLink>
          ))}
        </NavItems>
        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            {links.map((link) => (
              <NavLink key={link.href} onClick={() => setIsOpen(false)} href={link.href}>
                {link.label}
              </NavLink>
            ))}
            <GithubButton
              href={Bio.github}
              target="_blank"
              rel="noreferrer"
              style={{
                background: theme.primary,
                color: theme.text_primary,
                width: '40%',
              }}
            >
              GitHub
            </GithubButton>
            <GithubButton href={Bio.upwork} target="_blank" rel="noreferrer">
              Upwork
            </GithubButton>
          </MobileMenu>
        )}
        <ButtonContainer>
          <GithubButton href={Bio.upwork} target="_blank" rel="noreferrer">
            Upwork
          </GithubButton>
          <GithubButton href={Bio.linkedin} target="_blank" rel="noreferrer">
            LinkedIn
          </GithubButton>
          <GithubButton href={Bio.github} target="_blank" rel="noreferrer">
            GitHub
          </GithubButton>
        </ButtonContainer>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
